import Popup from 'reactjs-popup';
import { useState } from 'react';
import { ContactUsForm } from './ContactUsForm';
import { Icon } from '../../Atoms/Icon';
import { TextSpan, TextColor, TextWeight } from '../../Atoms/Text';
import { MODAL_CONTENT_STYLE } from '../../../utils/styleHelpers';

const contentStyle = {
  ...MODAL_CONTENT_STYLE,
  width: '400px'
};

interface ContactUsLinkProps {
  linkText: string;
  dataTestId?: string;
  textStyle?: string;
  color?: TextColor;
  weight?: TextWeight;
}

export function ContactUsLink({
  linkText,
  dataTestId,
  textStyle,
  color = 'grey5',
  weight = 'normal'
}: ContactUsLinkProps) {
  const [open, setOpen] = useState(false);

  const onClose = async () => {
    setOpen(false);
  };

  return (
    <>
      <button
        className="flex items-center space-x-1"
        onClick={() => setOpen(true)}>
        <Icon type="contact" />
        <TextSpan
          className={textStyle || 'text-xs'}
          dataCy={dataTestId}
          dataTestId={dataTestId}
          color={color}
          weight={weight}>
          {linkText}
        </TextSpan>
      </button>
      <Popup
        contentStyle={contentStyle}
        closeOnDocumentClick={false}
        modal={true}
        open={open}
        onClose={onClose}>
        <ContactUsForm onClose={onClose} />
      </Popup>
    </>
  );
}
